export { default } from './TicketCardWithManagerList';
